import React, {Component} from "react";
import {Trans} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Card, Col, Row} from "antd";
import Drawer from 'bukku/components/Ant/Drawer';
import Styled from './style';

const { Meta } = Card;

class Start extends Component {
    renderProfileCover = () => <img src="/assets/img/icons/company.png" alt="" />;

    renderContactCover = () => <img src="/assets/img/icons/contact.png" alt="" />;

    renderProductCover = () => <img src="/assets/img/icons/product.png" alt="" />;

    renderAccountCover = () => <img src="/assets/img/icons/accounting.png" alt="" />;

    renderOpeningCover = () => <img src="/assets/img/icons/balance.png" alt="" />;

    renderSettingCover = () => <img src="/assets/img/icons/gear.png" alt="" />;

    render() {
        const {
            open,
            onClose,
        } = this.props;

        return (
            <Drawer
                title={
                    <Trans>
                        Getting Started
                    </Trans>
                }
                placement="right"
                closable
                onClose={onClose}
                open={open}
                destroyOnClose
                onClick={e => e.stopPropagation()}
            >
                <Styled>

                    <Row className="content-row" type="flex" gutter={[0, 18]}>
                        <Col span={24}>
                            <Link to="/cp/profile">
                                <Card hoverable size="small" cover={this.renderProfileCover()}>
                                    <Meta
                                        title={
                                            <Trans>
                                                Company Profile
                                            </Trans>
                                        }
                                        description={
                                            <Trans>
                                                Update the information that appears on your invoices,
                                                &nbsp;receipts & other PDFs.
                                            </Trans>
                                        }
                                    />
                                </Card>
                            </Link>
                        </Col>

                        <Col span={24}>
                            <Link to="/contacts">
                                <Card hoverable size="small" cover={this.renderContactCover()}>
                                    <Meta
                                        title={
                                            <Trans>
                                                Add Contacts
                                            </Trans>
                                        }
                                        description={
                                            <Trans>
                                                Add your list of customers, suppliers & employees into Bukku.
                                            </Trans>
                                        }
                                    />
                                </Card>
                            </Link>
                        </Col>

                        <Col span={24}>
                            <Link to="/products">
                                <Card hoverable size="small" cover={this.renderProductCover()}>
                                    <Meta
                                        title={
                                            <Trans>
                                                Add Products
                                            </Trans>
                                        }
                                        description={
                                            <Trans>
                                                Add the list of products & services that
                                                &nbsp;you are selling or buying.
                                            </Trans>
                                        }
                                    />
                                </Card>
                            </Link>
                        </Col>

                        <Col span={24}>
                            <Link to="/accounting/accounts">
                                <Card hoverable size="small" cover={this.renderAccountCover()}>
                                    <Meta
                                        title={
                                            <Trans>
                                                Chart of Accounts
                                            </Trans>
                                        }
                                        description={
                                            <Trans>
                                                Review & update the chart of accounts
                                                &nbsp;to fit your business requirements.
                                            </Trans>
                                        }
                                    />
                                </Card>
                            </Link>
                        </Col>

                        <Col span={24}>
                            <Link to="/accounting/accounts/opening-balance">
                                <Card hoverable size="small" cover={this.renderOpeningCover()}>
                                    <Meta
                                        title={
                                            <Trans>
                                                Opening Balance
                                            </Trans>
                                        }
                                        description={
                                            <Trans>
                                                Enter the opening balances
                                                &nbsp;(When you have outstanding account balances
                                                &nbsp;captured by another software).
                                            </Trans>
                                        }
                                    />
                                </Card>
                            </Link>
                        </Col>

                        <Col span={24}>
                            <Link to="/cp/settings">
                                <Card hoverable size="small" cover={this.renderSettingCover()}>
                                    <Meta
                                        title={
                                            <Trans>Company Settings</Trans>
                                        }
                                        description={
                                            <Trans>
                                                Update all settings related to your company account.
                                            </Trans>
                                        }
                                    />
                                </Card>
                            </Link>
                        </Col>
                    </Row>
                </Styled>
            </Drawer>
        );
    }
}
export default connect()(withI18n()(Start));
